module.exports = {
      id: "phone-usage",
      viewBox: "0 0 12 12",
      url: __webpack_public_path__ + "sprite.b16108e5f95a8323b5a812454e446fa5.svg#phone-usage",
      toString: function () {
        return this.url;
      }
    }